import React, { useState, createRef } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './AppMenu.css';
import * as userSavedColumnOrderService from '../usersavedcolumnorder/userSavedColumnOrderService';
import LeftMenuItem from '../components/LeftMenuItem';

const ResponsiveGridLayout = WidthProvider(Responsive);
const LeftMenu = ({ leftMenuItems, collapse, toggleMenu, t, selectedMenuItem }) => {
  const [dragging, setDragging] = useState(false);
  const [layout, setLayout] = useState(
    leftMenuItems.map((item, index) => ({
      i: item.key,
      x: 0,
      y: index * 1,
      w: 1,
      h: 1
    }))
  );

  function handleBreakPointChange(newBreakpoint) {}

  const fixResizeUIbugs = () => {
    window.dispatchEvent(new Event('resize'));
  };

  const handleDragStop = (layout) => {
    const sortedLayout = [...layout].sort((a, b) => a.y - b.y);
    const layoutKeys = sortedLayout.map((item) => item.i);
    userSavedColumnOrderService.saveLeftMenuColumnOrder(JSON.stringify(layoutKeys));
    setDragging(false);
  };

  return (
    <ResponsiveGridLayout
      className="layout"
      isDraggable={true}
      isResizable={false}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 1, md: 1, sm: 1, xs: 1, xxs: 1 }}
      rowHeight={45}
      onBreakpointChange={handleBreakPointChange}
      onDragStart={() => setDragging(true)}
      onDragStop={handleDragStop}
      onResizeStop={() => fixResizeUIbugs()}
    >
      {leftMenuItems
        .filter((item) => item.visible)
        .map((item, index) => (
          <div key={item.key} ref={createRef} className="menuItemLink">
            <LeftMenuItem ref={createRef} leftMenuItem={item} collapse={collapse} dragging={dragging} selectedMenuItem={selectedMenuItem} />
          </div>
        ))}
    </ResponsiveGridLayout>
  );
};

export default LeftMenu;
